<template>
  <v-container
    v-if="!loading"
    fluid
  >
    <v-row
      class="bloc-cards"
    >
      <v-col
        v-for="(analysis) in analyses"
        :key="analysis.id"
        class="box-card"
        xl="4"
        lg="4"
        md="6"
        sm="12"
        xs="12"
      >
        <MeasureCard
          v-if="hasPermission('analyses.view')"
          :id="analysis.id"
          :populateWith="analysis"
          :componentId="componentId"
          :site="site"
          :analysisMeasureHistory="analysis.history ? analysis.history.measures : []"
          :isCompletedOrLocked="isCompletedOrLocked"
        >
          <template v-slot:title>
            {{ getAnalysisTypeName(analysis.analysisType) }}
          </template>
        </MeasureCard>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { isPlainObject } from 'lodash';
import { mapGetters } from 'vuex';
import MeasureCard from '@/components/sites/MeasureCard.vue';

export default {
    components: {
        MeasureCard,
    },
    props: {
        componentId: {
            type: String,
            default: null,
        },
        analyses: {
            type: Array,
            default: () => [],
        },
        site: {
            type: Object,
            required: true,
        },
        activeView: {
            type: String,
            default: 'gridView',
        },
        isCompletedOrLocked: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            loading: false,
            measureHistory: [],
        };
    },
    computed: {
        ...mapGetters([
            'hasPermission',
            'siteLang',
            'userLang',
            'teamMainLang',
        ]),
    },
    async created() {
        await this.getMeasureHistory();
    },
    methods: {
        getAnalysisTypeName(analysisType) {
            const { name, measureUnit } = analysisType;
            const unit = isPlainObject(measureUnit) ? ` (${measureUnit[this.siteLang] || this.$t('measures.labels.notSet')})` : '';
            const localName = name[this.siteLang] || name[this.userLang] || name[this.teamMainLang];
            return `${localName}${unit}`;
        },

        async getMeasureHistory() {
            this.loading = true;
            if (this.analyses[0]) {
                const component = this.analyses[0].source.ref;
                // eslint-disable-next-line no-underscore-dangle
                const activity = this.analyses[0].activity.id || this.analyses[0].activity._id;
                const response = await this.$rq.getMeasureHistory({
                    component,
                    activity,
                });
                const componentAnalysesMeasureHistories = response.data.results;
                componentAnalysesMeasureHistories.forEach(history => {
                    this.analyses.forEach(analysis => {
                        if (analysis.analysisType.ref === history.source.analysisType) {
                            Object.assign(analysis, { history });
                        }
                    });
                });
            }
            this.loading = false;
        },

    },
};
</script>
<style lang="scss">
    @media screen and (max-width: 600px) {
        .box-card {
            min-width: 100%;
        }
    }
</style>
